import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { formatDate } from '@angular/common';


import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { Observable, Subscription } from 'rxjs';
import { moveItemInArray, CdkDragDrop } from "@angular/cdk/drag-drop";
import { ToastrService } from 'ngx-toastr';

import { ApiEntranceExitEvent, ApiEntranceExitQuestion, ApiSetEntranceExitEventsRequest, SettingFile, ApiFile } from '../api-client-module';
import { ProjectLanguage } from '../firestore-models/project-language';
import { EntranceExitEvent } from '../firestore-models/entrance-exit-event';
import { Facility } from '../firestore-models/facility';
import { Floor } from '../firestore-models/floor';
import { UploadedFile } from '../firestore-models/uploaded-file';

import { ConfigurationService } from '../configuration.service';
import { ApiClientService } from '../api-client.service';
import { SpinnerService } from '../services/spinner.service';

import { AppConst } from '../app-const';
import { ApiReservationQuestion } from '../api-client-module';
import { MultiNameDialogComponent } from '../common/multi-name-dialog/multi-name-dialog.component';
import { MultiDescDialogComponent } from '../common/multi-desc-dialog/multi-desc-dialog.component';
import { MultiSendMailTitleDialogComponent } from '../common/multi-send-mail-title-dialog/multi-send-mail-title-dialog.component';
import { MultiSendMailMessageDialogComponent } from '../common/multi-send-mail-message-dialog/multi-send-mail-message-dialog.component';

import { SelectEntranceExitQuestionsDialogComponent } from './select-entrance-exit-questions-dialog/select-entrance-exit-questions-dialog.component';
import { SelectEntranceExitEventFloorsDialogComponent } from './select-entrance-exit-event-floors-dialog/select-entrance-exit-event-floors-dialog.component';
import { SelectUploadedFileDialogComponent } from '../select-uploaded-file-dialog/select-uploaded-file-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter, NativeDateAdapter } from '@angular/material/core';

@Component({
  selector: 'app-entrance-exit-event',
  templateUrl: './entrance-exit-event.component.html',
  styleUrls: ['./entrance-exit-event.component.css'],
  standalone: false,
})
export class EntranceExitEventComponent implements OnInit {

  //イベント情報
  event?: ApiEntranceExitEvent;
  //各予約設備情報に紐付くプロジェクトID
  projectId: string;
  questionIDs: string[] = [];

  display: string = 'basic';
  isAdded: boolean = true;
  isInit: boolean = true;
  projectLanguages!: Array<ProjectLanguage>;

  //イベント情報フォーム
  eventFormGroup!: FormGroup;
  facilityIdControl!: FormControl;
  namesControl!: FormControl;
  descriptionsControl!: FormControl;
  openStartDateControl!: FormControl;
  openEndDateControl!: FormControl;
  entryStartDateControl!: FormControl;
  entryEndDateControl!: FormControl;
  isVisibledCampanyNameControl!: FormControl;
  isVisibledDepartmentControl!: FormControl;
  isVisibledJobTitleControl!: FormControl;
  isVisibledSurnameChineseControl!: FormControl;
  isVisibledNameChineseControl!: FormControl;
  isVisibledFamilyNameControl!: FormControl;
  isVisibledFirstNameControl!: FormControl;
  isVisibledGenderControl!: FormControl;
  isVisibledBirthdayControl!: FormControl;
  isVisibledAddressControl!: FormControl;
  isVisibledMobilePhoneNumberControl!: FormControl;
  entryMailTitlesControl!: FormControl;
  entryMailMessages1Control!: FormControl;
  entryMailMessages2Control!: FormControl;
  entryMailMessages3Control!: FormControl;
  isVisibledQrCompanyNameControl!: FormControl;
  isVisibledQrDepartmentControl!: FormControl;
  isVisibledQrJobTitleControl!: FormControl;
  isVisibledQrSurnameNameChineseControl!: FormControl;
  isVisibledQrFamilyFirstNameControl!: FormControl;
  isVisibledQrGenderControl!: FormControl;
  isVisibledQrBirthdayControl!: FormControl;
  isVisibledQrAddressControl!: FormControl;
  isVisibledQrMobilePhoneNumberControl!: FormControl;

  private facilitiesCollection!: AngularFirestoreCollection<Facility>;
  facilities!: Observable<Facility[]>;
  private eventsCollection!: AngularFirestoreCollection<EntranceExitEvent>;

  floors: Floor[] = [];
  hallsCollectionName = AppConst.FIRESTORE_HALLS;

  eventFiles: SettingFile[] = [];

  projectBaseLang: string = 'ja';
  currentLang: string = 'ja';
  private langChangeSub!: Subscription; // TranslateServiceの購読を管理

  constructor(
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private angularFirestore: AngularFirestore,
    private configurationService: ConfigurationService,
    private apiClientService: ApiClientService,
    private spinnerService: SpinnerService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private dateAdapter: DateAdapter<any>
  ) {
    this.projectId = this.configurationService.getProjectId();
    this.eventFormGroup = this.formBuilder.group({});
   }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.facilitiesCollection = this.angularFirestore.collection<Facility>(
      AppConst.FIRESTORE_FACILITIES, ref => ref.where('project_id', '==', this.projectId).orderBy('facility_id', 'asc'));
    this.facilities = this.facilitiesCollection.valueChanges({ idField: 'id' });
    this.projectBaseLang = this.configurationService.getProject().project_base_lang;
    this.eventsCollection = this.angularFirestore.collection<EntranceExitEvent>(
      AppConst.FIRESTORE_ENTRANCE_EXIT_EVENTS, ref => ref.where('project_id', '==', this.projectId));
    this.currentLang = this.translate.currentLang; //(0703)
    // 1. コンポーネント初期化時に現在の言語でカレンダーを設定
    this.setCalendarLocale(this.currentLang);

    // 2. アプリケーションの言語が変更されたら、カレンダーの言語も動的に追従させる
    this.langChangeSub = this.translate.onLangChange.subscribe(event => {
      this.setCalendarLocale(event.lang);
    });
    this.eventsCollection.valueChanges({ idField: 'id' }).subscribe(events => {
      const apiEvent: ApiEntranceExitEvent = {
        id: '',
        project_id: this.projectId,
        facility_id: '',
        names: null as any,
        descriptions: null as any,
        files: [],
        open_start_date: null,
        open_end_date: null,
        entry_start_date: null,
        entry_end_date: null,
        is_visibled_company_name: false,
        is_visibled_department: false,
        is_visibled_job_title: false,
        is_visibled_surname_chinese: false,
        is_visibled_name_chinese: false,
        is_visibled_family_name: false,
        is_visibled_first_name: false,
        is_visibled_birthday: false,
        is_visibled_gender: false,
        is_visibled_address: false,
        is_visibled_mobile_phone_number: false,
        questions: [],
        entry_mail_titles: [],
        entry_mail_messages1: null as any,
        entry_mail_messages2: null as any,
        entry_mail_messages3: null as any,
        entrances: [],
        exits: [],
        floor_ids: [],
        current: true,
        is_visibled_qr_company_name: false,
        is_visibled_qr_department: false,
        is_visibled_qr_job_title: false,
        is_visibled_qr_surname_name_chinese: false,
        is_visibled_qr_family_first_name: false,
        is_visibled_qr_gender: false,
        is_visibled_qr_birthday: false,
        is_visibled_qr_address: false,
        is_visibled_qr_mobile_phone_number: false,
        enabled: true,
      };

      if (events.length > 0) {
        const currentEvent = events.find(event => event.current);
        if (!!currentEvent) {
          let questions: Array<ApiEntranceExitQuestion> = new Array<ApiEntranceExitQuestion>();
          if (currentEvent.questions) {
            for( const question of currentEvent.questions) {
              const question_check_date_range_upper: any = question.question_check_date_range_upper ? new Date(question!.question_check_date_range_upper.seconds * 1000) : null;
              const question_check_date_range_lower: any = question.question_check_date_range_lower ? new Date(question!.question_check_date_range_lower.seconds * 1000) : null;
              const question_check_base_date: any = question.question_check_base_date ? new Date(question!.question_check_base_date.seconds * 1000) : null;
              let apiQuestion: ApiEntranceExitQuestion = {
                question_id: question.question_id,
                display_no: question.display_no,
                question_names: question.question_names,
                question_comps: question.question_comps,
                question_type: question.question_type,
                question_select_items: question.question_select_items,
                question_check: question.question_check,
                question_check_range_upper: question.question_check_range_upper,
                question_check_range_lower: question.question_check_range_lower,
                question_check_date_range_upper: question_check_date_range_upper,
                question_check_date_range_lower: question_check_date_range_lower,
                question_check_base_date: question_check_base_date,
                question_check_base_date_to_start: question.question_check_base_date_to_start,
                question_check_base_date_to_end: question.question_check_base_date_to_end,
                question_check_col_count_upper: question.question_check_col_count_upper,
                question_check_col_count_lower: question.question_check_col_count_lower,
                project_id: question.project_id,
                enabled: question.enabled,
              };
              questions.push(apiQuestion);
            }
          }
  
          apiEvent.id = currentEvent.id!;
          apiEvent.facility_id = currentEvent.facility_id;
          apiEvent.names = currentEvent.names;
          apiEvent.descriptions = currentEvent.descriptions;
          apiEvent.files = currentEvent.files;
          apiEvent.open_start_date = !!currentEvent.open_start_date ? currentEvent.open_start_date.toDate() : null;
          apiEvent.open_end_date = !!currentEvent.open_end_date ? currentEvent.open_end_date.toDate() : null;
          apiEvent.entry_start_date = !!currentEvent.entry_start_date ? currentEvent.entry_start_date.toDate() : null;
          apiEvent.entry_end_date = !!currentEvent.entry_end_date ? currentEvent.entry_end_date.toDate() : null;
          apiEvent.is_visibled_company_name = currentEvent.is_visibled_company_name;
          apiEvent.is_visibled_department = currentEvent.is_visibled_department;
          apiEvent.is_visibled_job_title = currentEvent.is_visibled_job_title;
          apiEvent.is_visibled_surname_chinese = currentEvent.is_visibled_surname_chinese;
          apiEvent.is_visibled_name_chinese = currentEvent.is_visibled_name_chinese;
          apiEvent.is_visibled_family_name = currentEvent.is_visibled_family_name;
          apiEvent.is_visibled_first_name = currentEvent.is_visibled_first_name;
          apiEvent.is_visibled_birthday = currentEvent.is_visibled_birthday;
          apiEvent.is_visibled_gender = currentEvent.is_visibled_gender;
          apiEvent.is_visibled_address = currentEvent.is_visibled_address;
          apiEvent.is_visibled_mobile_phone_number = currentEvent.is_visibled_mobile_phone_number;
          apiEvent.questions = questions;
          apiEvent.entry_mail_titles = currentEvent.entry_mail_titles;
          apiEvent.entry_mail_messages1 = currentEvent.entry_mail_messages1;
          apiEvent.entry_mail_messages2 = currentEvent.entry_mail_messages2;
          apiEvent.entry_mail_messages3 = currentEvent.entry_mail_messages3;
          apiEvent.entrances = currentEvent.entrances;
          apiEvent.exits = currentEvent.exits;
          apiEvent.floor_ids = currentEvent.floor_ids;
          apiEvent.current = currentEvent.current;
          apiEvent.is_visibled_qr_company_name = currentEvent.is_visibled_qr_company_name;
          apiEvent.is_visibled_qr_department = currentEvent.is_visibled_qr_department;
          apiEvent.is_visibled_qr_job_title = currentEvent.is_visibled_qr_job_title;
          apiEvent.is_visibled_qr_surname_name_chinese = currentEvent.is_visibled_qr_surname_name_chinese;
          apiEvent.is_visibled_qr_family_first_name = currentEvent.is_visibled_qr_family_first_name;
          apiEvent.is_visibled_qr_gender = currentEvent.is_visibled_qr_gender;
          apiEvent.is_visibled_qr_birthday = currentEvent.is_visibled_qr_birthday;
          apiEvent.is_visibled_qr_address = currentEvent.is_visibled_qr_address;
          apiEvent.is_visibled_qr_mobile_phone_number = currentEvent.is_visibled_qr_mobile_phone_number;
          apiEvent.enabled = currentEvent.enabled;
          this.isAdded = false;
        }

      }
      this.event = apiEvent;

      this.getQuestionIDs();
      this.getFloors();
      this.getFiles();
      this.createForm();
      this.facilityIdControl = this.eventFormGroup.get('facilityId') as FormControl;
      this.namesControl = this.eventFormGroup.get('names') as FormControl;
      this.descriptionsControl = this.eventFormGroup.get('descriptions') as FormControl;
      this.openStartDateControl = this.eventFormGroup.get('openStartDate') as FormControl;
      this.openEndDateControl = this.eventFormGroup.get('openEndDate') as FormControl;
      this.entryStartDateControl = this.eventFormGroup.get('entryStartDate') as FormControl;
      this.entryEndDateControl = this.eventFormGroup.get('entryEndDate') as FormControl;
      this.isVisibledCampanyNameControl = this.eventFormGroup.get('isVisibledCampanyName') as FormControl;
      this.isVisibledDepartmentControl = this.eventFormGroup.get('isVisibledDepartment') as FormControl;
      this.isVisibledJobTitleControl = this.eventFormGroup.get('isVisibledJobTitle') as FormControl;
      this.isVisibledSurnameChineseControl = this.eventFormGroup.get('isVisibledSurnameChinese') as FormControl;
      this.isVisibledNameChineseControl = this.eventFormGroup.get('isVisibledNameChinese') as FormControl;
      this.isVisibledFamilyNameControl = this.eventFormGroup.get('isVisibledFamilyName') as FormControl;
      this.isVisibledFirstNameControl = this.eventFormGroup.get('isVisibledFirstName') as FormControl;
      this.isVisibledGenderControl = this.eventFormGroup.get('isVisibledGender') as FormControl;
      this.isVisibledBirthdayControl = this.eventFormGroup.get('isVisibledBirthday') as FormControl;
      this.isVisibledAddressControl = this.eventFormGroup.get('isVisibledAddress') as FormControl;
      this.isVisibledMobilePhoneNumberControl = this.eventFormGroup.get('isVisibledMobilePhoneNumber') as FormControl;
      this.entryMailTitlesControl = this.eventFormGroup.get('entryMailTitles') as FormControl;
      this.entryMailMessages1Control = this.eventFormGroup.get('entryMailMessages1') as FormControl;
      this.entryMailMessages2Control = this.eventFormGroup.get('entryMailMessages2') as FormControl;
      this.entryMailMessages3Control = this.eventFormGroup.get('entryMailMessages3') as FormControl;
      this.isVisibledQrCompanyNameControl = this.eventFormGroup.get('isVisibledQrCompanyName') as FormControl;
      this.isVisibledQrDepartmentControl = this.eventFormGroup.get('isVisibledQrDepartment') as FormControl;
      this.isVisibledQrJobTitleControl = this.eventFormGroup.get('isVisibledQrJobTitle') as FormControl;
      this.isVisibledQrSurnameNameChineseControl = this.eventFormGroup.get('isVisibledQrSurnameNameChinese') as FormControl;
      this.isVisibledQrFamilyFirstNameControl = this.eventFormGroup.get('isVisibledQrFamilyFirstName') as FormControl;
      this.isVisibledQrGenderControl = this.eventFormGroup.get('isVisibledQrGender') as FormControl;
      this.isVisibledQrBirthdayControl = this.eventFormGroup.get('isVisibledQrBirthday') as FormControl;
      this.isVisibledQrAddressControl = this.eventFormGroup.get('isVisibledQrAddress') as FormControl;
      this.isVisibledQrMobilePhoneNumberControl = this.eventFormGroup.get('isVisibledQrMobilePhoneNumber') as FormControl;
    });
  }

  ngAfterViewInit(): void {
  }

  /** //(0703)
  * Datepickerのロケールを設定するプライベートメソッド
  * @param lang 設定したい言語コード (例: 'en', 'ja')
  */
  private setCalendarLocale(lang: string): void {
    // 言語に応じたロケールを設定
    const locale = lang === 'en' ? 'en-US' : 'ja-JP';
    this.dateAdapter.setLocale(locale);
  }

  //以下、フォームの記入エラー表示
  public getErrorMessageToNames() {
    return this.namesControl.hasError('required')
    ? this.translate.instant(this.translate.instant('必須項目'))
    : '';
  }

  public getErrorMessageToDescriptions() {
    return this.descriptionsControl.hasError('required')
    ? this.translate.instant(this.translate.instant('必須項目'))
    : '';
  }

  public getErrorMessageToFacilityId() {
    return this.facilityIdControl.hasError('required')
    ? this.translate.instant('必須項目')
    : '';
  }


  public getErrorMessageToOpenDate() {
    return this.openStartDateControl.hasError('required') || this.openEndDateControl.hasError('required')
    ? this.translate.instant('必須項目')
    : '';
  }

  public getErrorMessageToEntryDate() {
    return this.entryStartDateControl.hasError('required') || this.entryEndDateControl.hasError('required')
    ? this.translate.instant('必須項目')
    : '';
  }

  public getErrorMessageToEntryMailTitles() {
    return this.entryMailTitlesControl.hasError('required')
    ? this.translate.instant('必須項目')
    : '';
  }

  public getErrorMessageToEntryMailMessages1() {
    return this.entryMailMessages1Control.hasError('required')
    ? this.translate.instant('必須項目')
    : '';
  }

  //フォームの値を各要素に代入
  private createForm() {
    this.eventFormGroup = this.formBuilder.group(
      {
        facilityId: [this.event!.facility_id, [Validators.required]],
        names: [this.event!.names, [Validators.required]],
        descriptions: [this.event!.descriptions, [Validators.required]],
        openStartDate: [this.event!.open_start_date, [Validators.required]],
        openEndDate: [this.event!.open_end_date, [Validators.required]],
        entryStartDate: [this.event!.entry_start_date, [Validators.required]],
        entryEndDate: [this.event!.entry_end_date, [Validators.required]],
        isVisibledCampanyName: [this.event!.is_visibled_company_name, []],
        isVisibledDepartment: [this.event!.is_visibled_department, []],
        isVisibledJobTitle: [this.event!.is_visibled_job_title, []],
        isVisibledSurnameChinese: [this.event!.is_visibled_surname_chinese, []],
        isVisibledNameChinese: [this.event!.is_visibled_name_chinese, []],
        isVisibledFamilyName: [this.event!.is_visibled_family_name, []],
        isVisibledFirstName: [this.event!.is_visibled_first_name, []],
        isVisibledGender: [this.event!.is_visibled_gender, []],
        isVisibledBirthday: [this.event!.is_visibled_birthday, []],
        isVisibledAddress: [this.event!.is_visibled_address, []],
        isVisibledMobilePhoneNumber: [this.event!.is_visibled_mobile_phone_number, []],
        entryMailTitles: [this.event!.entry_mail_titles, [Validators.required]],
        entryMailMessages1: [this.event!.entry_mail_messages1, [Validators.required]],
        entryMailMessages2: [this.event!.entry_mail_messages2, []],
        entryMailMessages3: [this.event!.entry_mail_messages3, []],
        isVisibledQrCompanyName: [this.event!.is_visibled_qr_company_name, []],
        isVisibledQrDepartment: [this.event!.is_visibled_qr_department, []],
        isVisibledQrJobTitle: [this.event!.is_visibled_qr_job_title, []],
        isVisibledQrSurnameNameChinese: [this.event!.is_visibled_qr_surname_name_chinese, []],
        isVisibledQrFamilyFirstName: [this.event!.is_visibled_qr_family_first_name, []],
        isVisibledQrGender: [this.event!.is_visibled_qr_gender, []],
        isVisibledQrBirthday: [this.event!.is_visibled_qr_birthday, []],
        isVisibledQrAddress: [this.event!.is_visibled_qr_address, []],
        isVisibledQrMobilePhoneNumber: [this.event!.is_visibled_qr_mobile_phone_number, []],
      }, {
        validator: []
      }
    );
  }

  //名称ダイアログ
  openNameDialog(): void {
    const dialogRef = this.dialog.open(MultiNameDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { names: this.event!.names }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.event!.names = result;
        this.namesControl.setValue(this.event!.names);
      }
    });
  }

  //詳細ダイアログ
  openDescDialog(): void {
    const dialogRef = this.dialog.open(MultiDescDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { descs: this.event!.descriptions }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.event!.descriptions = result;
        this.descriptionsControl.setValue(this.event!.descriptions);
      }
    });
  }

  // エントリー完了時メール送信タイトルダイアログ
  openEntryMailMessageTitleDialog(): void {
    const dialogRef = this.dialog.open(MultiSendMailTitleDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { send_mail_titles: this.event!.entry_mail_titles }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.event!.entry_mail_titles = result;
        this.entryMailTitlesControl.setValue(this.event!.entry_mail_titles);
      }
    });
  }

  // エントリー完了時メール送信本文（文頭）ダイアログ
  openEntryMailMessageHeaderDialog(): void {
    const dialogRef = this.dialog.open(MultiSendMailMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { send_mail_messages: this.event!.entry_mail_messages1 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.event!.entry_mail_messages1 = result;
        this.entryMailMessages1Control.setValue(this.event!.entry_mail_messages1);
      }
    });
  }

  // エントリー完了時メール送信本文（文中）ダイアログ
  openEntryMessageMiddleDialog(): void {
    const dialogRef = this.dialog.open(MultiSendMailMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { send_mail_messages: this.event!.entry_mail_messages2 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.event!.entry_mail_messages2 = result;
        this.entryMailMessages2Control.setValue(this.event!.entry_mail_messages2);
      }
    });
  }

  // エントリー完了時メール送信本文（末尾）ダイアログ
  openEntryMessageFooterDialog(): void {
    const dialogRef = this.dialog.open(MultiSendMailMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { send_mail_messages: this.event!.entry_mail_messages3 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.event!.entry_mail_messages3 = result;
        this.entryMailMessages3Control.setValue(this.event!.entry_mail_messages3);
      }
    });
  }

  // 設問選択ダイアログ
  openSelectQuestionsDialog(): void {
    const dialogRef = this.dialog.open(SelectEntranceExitQuestionsDialogComponent, {
      width: '80%',
      disableClose: true,
      data: { floor: null }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result && result.length > 0) {
        if (!this.event!.questions) {
          this.event!.questions = new Array<ApiEntranceExitQuestion>();
        }
        var questionIds = [];
        for ( const question of this.event!.questions ) {
          if (question) {
            questionIds.push(question.question_id);
          }
        }
        let isChanged: boolean = false;
        for (const row of result) {
          if (!questionIds.includes(row.question_id)) {
            this.event!.questions.push(row);
            isChanged = true;
          }
        }
        if (isChanged && this.event) {
          this.getQuestionIDs();
        }
      }
    });
  }

  // イベントに紐付く設問情報設定
  private getQuestionIDs() {
    this.questionIDs = [];
    if (!!this.event! && !!this.event!.questions && this.event!.questions.length > 0) {
      for (const question of this.event?.questions) {
        this.questionIDs.push(question.question_id);
      }
    }
  }
  
  // 設問情報並べ替え
  onDropQuestion(event: CdkDragDrop<string[]>) {
    let questions = [];
    if (this.event && this.event.questions && this.event.questions.length > 1) {
      for (const question of this.event.questions) {
        questions.push({...question});
      }
      moveItemInArray(this.questionIDs, event.previousIndex, event.currentIndex);
      let questionLists: Array<ApiReservationQuestion> = [];
      for (const question_id of this.questionIDs) {
        for (let question of questions) {
          if (question_id === question.question_id) {
            questionLists.push({...question});
          }
        }
      }
      this.event!.questions = questionLists;
    }
  }

  // 設問リストの削除
  deleteQuestion(question_id: string): void {
    if (!!this.event!.questions!) {
      this.event!.questions.forEach((question, index) => {
        if (question.question_id == question_id) {
          this.event!.questions.splice(index, 1);
        }
      })
    }
  }

  //　イベントに紐付くフロア・表示グループ情報設定
  private getFloors() {
    this.floors = [];
    if (!!this.event!.floor_ids && this.event!.floor_ids.length > 0) {
      // NOTE: in で取得できるのは最大10までのため、該当プロジェクトの展示情報を全て取得してから
      //       イベント情報に登録されている id で絞り込む。
      this.angularFirestore.collection<Floor>(
        AppConst.FIRESTORE_FLOORS, ref => ref.where('project_id', '==', this.projectId)
        ).valueChanges({ idField: 'id' }).subscribe(docs => {
          this.floors = [];
          if (!!docs) {
            for (const floorId of this.event!.floor_ids!) {
              for (const floor of docs) {
                if (floorId === floor.id) {
                  this.floors.push(floor);
                  break;
                }
              }
            }
          }
      });
    }
  }


  //フロア・表示グループ選択ダイアログ
  openSelectFloorsDialog(): void {
    const dialogRef = this.dialog.open(SelectEntranceExitEventFloorsDialogComponent, {
      width: '80%',
      height: '90%',
      disableClose: true,
      data: { floor: null }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result && result.length > 0) {
        if (!this.event!.floor_ids) {
          this.event!.floor_ids = new Array<string>();
        }
        let isChanged: boolean = false;
        for (const row of result) {
          if (!this.event!.floor_ids.includes(row.id)) {
            this.event!.floor_ids.push(row.id);
            isChanged = true;
          }
        }
        if (!!isChanged) {
          this.getFloors();
        }
      }
    });
  }

  //フロア・表示グループリストの削除
  deleteFloor(id: string): void {
    if (!!this.event!.floor_ids!.includes(id)) {
      this.event!.floor_ids = this.event!.floor_ids!.filter(value => value !== id);
      this.getFloors();
    }
  }

  //フロア・表示グループリスト並べ替え
  onDropFloor(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.floors, event.previousIndex, event.currentIndex);
    let floorLists: Array<string> = [];
    for (const floor of this.floors) {
      floorLists.push(floor.id!);
    }
    this.event!.floor_ids = floorLists;
  }
  
  // 開催期間クリア
  clearOpenDate(): void {
    this.openStartDateControl.setValue(null);
    this.openEndDateControl.setValue(null);
  }

  // 募集期間クリア
  clearEntryDate(): void {
    this.entryStartDateControl.setValue(null);
    this.entryEndDateControl.setValue(null);
  }

  //入場口名変更
  onSelectEntranceValueChange(event: any, index: number): void {
    this.event!.entrances![index].name = event.target.value;
  }

  //退場口名変更
  onSelectExitValueChange(event: any, index: number): void {
    this.event!.exits![index].name = event.target.value;
  }

  //入場口追加ボタン
  appendEntrance(): void {
    if (!this.event!.entrances) {
      this.event!.entrances = new Array();
    }
    this.event!.entrances!.push({
      index: this.getUniqueStr(),
      name: '',
    });
  }

  //退場口追加ボタン
  appendExit(): void {
    if (!this.event!.exits) {
      this.event!.exits = new Array();
    }
    this.event!.exits!.push({
      index: this.getUniqueStr(),
      name: '',
    });
  }

  //入場口削除ボタン
  deleteEntrance(index: number): void {
    this.event!.entrances!.splice(index, 1);
  }

  //退場口削除ボタン
  deleteExit(index: number): void {
    this.event!.exits!.splice(index, 1);
  }
  
  //入場口並べ替え
  onDropEntrance(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.event!.entrances, event.previousIndex, event.currentIndex);
  }

  //退場口並べ替え
  onDropExit(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.event!.exits, event.previousIndex, event.currentIndex);
  }

  //入場口名設定
  changeEntranceName(event: any, index: number): void {
    this.event!.entrances![index].name = event.target.value;
  }

  //退場口名設定
  changeExitName(event: any, index: number): void {
    this.event!.exits![index].name = event.target.value;
  }
  
  getUniqueStr(){
    var strong = 1000;
    return new Date().getTime().toString(16)+Math.floor(strong*Math.random()).toString(16)+Math.floor(strong*Math.random()).toString(16)
  }

  // イベント画像ファイル設定
  private getFiles() {
    this.eventFiles = [];
    if (!!this.event!.files && this.event!.files.length > 0) {
      // NOTE: in で取得できるのは最大10までのため、該当プロジェクトのアップロードファイルを全て取得してから
      //       イベント情報に登録されている id で絞り込む。
      this.angularFirestore.collection<UploadedFile>(
        AppConst.FIRESTORE_UPLOADED_FILES, ref => ref.where('project_id', '==', this.projectId)
        ).valueChanges({ idField: 'id' }).subscribe(docs => {
          this.eventFiles = [];
          if (!!docs) {
            for (const file of this.event!.files!) {
              for (const uploadedFile of docs) {
                if (file.file_id === uploadedFile.id) {
                  const settingFile: SettingFile = {
                    id: uploadedFile.id,
                    file_name: uploadedFile.file_name,
                    download_url: uploadedFile.download_url,
                    lang_code: file.lang_code,
                  }
                  this.eventFiles.push(settingFile);
                  break;
                }
              }
            }
          }
      });
    }
  }

  // イベント画像ファイル並べ替え
  onDropFile(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.eventFiles, event.previousIndex, event.currentIndex);
    let files: Array<ApiFile> = [];
    for (const file of this.eventFiles) {
      files.push({file_id: file.id, lang_code: file.lang_code});
    }
    this.event!.files = files;
  }

  // 変更された言語を登録
  changeFileLang(i: number, event: any) {
    this.event!.files![i].lang_code = event.value;
    this.eventFiles![i].lang_code = event.value;
  }

  // イベント画像ファイル選択ダイアログ
  openSelectFilesDialog(): void {
    const dialogRef = this.dialog.open(SelectUploadedFileDialogComponent, {
      width: '80%',
      height: '90%',
      disableClose: true,
      data: { uploadedFile: null }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result && result.length > 0) {
        for (const row of result) {
          const lang = this.projectLanguages[0].lang_code;
          this.event!.files!.push({file_id: row.id, lang_code: lang});
        }
        this.getFiles();
      }
    });
  }

  deleteFiles(i: number): void {
    this.event!.files!.splice(i, 1);
    this.getFiles();
  }

  //追加・更新ボタン
  setEvent(): void {
    const openStartDate = new Date(formatDate(this.openStartDateControl.value, 'yyyy-MM-dd 00:00:00', 'en-US'));
    const openEndDate  = new Date(formatDate(this.openEndDateControl.value, 'yyyy-MM-dd 00:00:00', 'en-US'));
    const entryStartDate = new Date(formatDate(this.entryStartDateControl.value, 'yyyy-MM-dd 00:00:00', 'en-US'));
    const entryEndDate  = new Date(formatDate(this.entryEndDateControl.value, 'yyyy-MM-dd 00:00:00', 'en-US'));

    this.event!.facility_id = this.facilityIdControl.value;
    this.event!.open_start_date = openStartDate;
    this.event!.open_end_date = openEndDate;
    this.event!.entry_start_date = entryStartDate;
    this.event!.entry_end_date = entryEndDate;
    this.event!.is_visibled_company_name = this.isVisibledCampanyNameControl.value;
    this.event!.is_visibled_department = this.isVisibledDepartmentControl.value;
    this.event!.is_visibled_job_title = this.isVisibledJobTitleControl.value;
    this.event!.is_visibled_surname_chinese = this.isVisibledSurnameChineseControl.value;
    this.event!.is_visibled_name_chinese = this.isVisibledNameChineseControl.value;
    this.event!.is_visibled_family_name = this.isVisibledFamilyNameControl.value;
    this.event!.is_visibled_first_name = this.isVisibledFirstNameControl.value;
    this.event!.is_visibled_gender = this.isVisibledGenderControl.value;
    this.event!.is_visibled_birthday = this.isVisibledBirthdayControl.value;
    this.event!.is_visibled_address = this.isVisibledAddressControl.value;
    this.event!.is_visibled_mobile_phone_number = this.isVisibledMobilePhoneNumberControl.value;
    this.event!.entry_mail_titles = this.entryMailTitlesControl.value;
    this.event!.entry_mail_messages1 = this.entryMailMessages1Control.value;
    this.event!.entry_mail_messages2 = this.entryMailMessages2Control.value;
    this.event!.entry_mail_messages3 = this.entryMailMessages3Control.value;
    this.event!.is_visibled_qr_company_name = this.isVisibledQrCompanyNameControl.value;
    this.event!.is_visibled_qr_department = this.isVisibledQrDepartmentControl.value;
    this.event!.is_visibled_qr_job_title = this.isVisibledQrJobTitleControl.value;
    this.event!.is_visibled_qr_surname_name_chinese = this.isVisibledQrSurnameNameChineseControl.value;
    this.event!.is_visibled_qr_family_first_name = this.isVisibledQrFamilyFirstNameControl.value;
    this.event!.is_visibled_qr_gender = this.isVisibledQrGenderControl.value;
    this.event!.is_visibled_qr_birthday = this.isVisibledQrBirthdayControl.value;
    this.event!.is_visibled_qr_address = this.isVisibledQrAddressControl.value;
    this.event!.is_visibled_qr_mobile_phone_number = this.isVisibledQrMobilePhoneNumberControl.value;

    let request: ApiSetEntranceExitEventsRequest = {
      access_token: '',
      change_type: this.isAdded ? AppConst.DATA_CHANGE_TYPE_ADD : AppConst.DATA_CHANGE_TYPE_UPDATE,
      events: [this.event!]
    }
    this.spinnerService.openSpinner();
    this.apiClientService.setEntranceExitEvents(request).then(
      response => {
        if (response!.ret === AppConst.API_RET_SUCCESS) {
          this.toastr.success(this.translate.instant('登録しました。'))
        } else {
          console.error('api update error. ret='+response!.ret);
          this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 })
        }
      }
    ).catch(
      error => {
        console.log(error);
        this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
      }
    ).finally(
      () => {
        this.spinnerService.closeSpinner();
      }
    );
  }

  isValidSplatsQr(): boolean {
    let count = 0;
    count += this.isVisibledQrCompanyNameControl.value ? 1 : 0;
    count += this.isVisibledQrDepartmentControl.value ? 1 : 0;
    count += this.isVisibledQrJobTitleControl.value ? 1 : 0;
    count += this.isVisibledQrSurnameNameChineseControl.value ? 1 : 0;
    count += this.isVisibledQrFamilyFirstNameControl.value ? 1 : 0;
    count += this.isVisibledQrGenderControl.value ? 1 : 0;
    count += this.isVisibledQrBirthdayControl.value ? 1 : 0;
    count += this.isVisibledQrAddressControl.value ? 1 : 0;
    count += this.isVisibledQrMobilePhoneNumberControl.value ? 1 : 0;
    return count <= 5;
  }

}
